import { createStyles } from '@mui/styles'

const styles = createStyles(() => ({
    container: {
        marginBottom: '1em'
    },
    therapistDisplay: {
        color: 'black',
        fontWeight: 'bold'
    }

}))

export default styles
